module.exports = __webpack_public_path__ + "static/media/general_without_detail.c38af24a.svg";